<template>
  <div id="page">
    <div class="row topCardGrid">
        <sp-card :valor="cards.transportados" :descricao="$t('mobilidade.transporte.passageirosTransportados')" :lgGrid="4" :footerText="header"/>
        <sp-card :valor="cards.pagantes" :descricao="$t('mobilidade.transporte.gratuidades')" :lgGrid="4" :footerText="header"/>
        <sp-card :valor="cards.gratuidades" :descricao="$t('mobilidade.transporte.tarifasReduzida')" :lgGrid="4" :footerText="header"/>
    </div>
    <div class="row flex">
      <div class="flex">
            <sp-360-panel :title="$t('mobilidade.transporte.painel.estatistica.titulo', {periodo: periodo})" :footerText="dataRef">
                <div class="flex lg4 sm12 md4">
                    <va-tabs class="tabPadding" v-model="showTabEstatistico">
                        <va-tab v-for="option in showTabOptions" :key="option.atributo">
                            {{ option.label }}
                        </va-tab>
                    </va-tabs>
                </div>
                <div v-show="showTabEstatistico === 0">
                    <sp-360-chart :data="chartEstatistico.data" type="line" :options="chartEstatistico.options" class='chartPanel'/>
                </div>
                <div v-show="showTabEstatistico === 1">
                    <sp360-data-table class="flex" id="tabelaOrgao" ref="tabelaOrgao"
                        :apiMode="false"
                        :data="tabelaEstatisticas.dados"
                        :fields="tabelaEstatisticas.campos"
                        :perPage="tabelaEstatisticas.itemsPerPage"
                        :onEachSide="1"
                        :striped="true"
                    />
                </div>
            </sp-360-panel>
      </div>
    </div>
    <div class="row flex">
       <div class="flex">
            <sp-360-panel :title="$t('mobilidade.transporte.painel.consolidado.titulo', {periodo: periodo})" :footerText="dataRef">
                <div class="flex lg4 sm12 md4">
                    <va-tabs class="tabPadding" v-model="showTabConsolidado">
                        <va-tab v-for="option in showTabOptions" :key="option.atributo">
                            {{ option.label }}
                        </va-tab>
                    </va-tabs>
                </div>
                <div v-show="showTabConsolidado === 0">
                    <sp-360-chart :data="chartConsolidado.data" type="vertical-bar" :options="chartConsolidado.options" class='chartPanel'/>
                </div>
                <div v-show="showTabConsolidado === 1">
                    <sp360-data-table class="flex " id="tabelaOrgao" ref="tabelaOrgao"
                        :apiMode="false"
                        :data="tabelaConsolidados.dados"
                        :fields="tabelaConsolidados.campos"
                        :perPage="tabelaConsolidados.itemsPerPage"
                        :onEachSide="1"
                        :sortFunctions="tabelaConsolidados.sortFunctions"
                        :striped="true"
                    />
                </div>
            </sp-360-panel>
       </div>
    </div>
  </div>
</template>

<script>

import * as d3 from 'd3'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import ChartAnnotation from 'chartjs-plugin-annotation'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import AutoUpdate from '@/services/AutoUpdate'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360datatable from '../../ui/dataTable/sp360datatable.vue'

export default {
  name: 'mobilidade-transportes',
  mixins: [],
  components: { SpMap, Multiselect, SpCard, Sp360Chart, Sp360Panel, Sp360DataTable, Sp360datatable, ChartAnnotation },

  data () {
    return {
      dataInicio: new Date('01/01/2019'),
      dataFim: new Date(),
      agrupamentos: ['NENHUM', 'DIARIO', 'MENSAL_DIA_DA_SEMANA', 'ULTIMO_MES', 'MENSAL', 'DIARIO'],
      fonte: '',
      dataRef: '',
      cardRef: '',
      showTab: 0,
      showTabEstatistico: 0,
      showTabConsolidado: 0,
      showTabOptions: [{ atributo: 0, label: 'Grafico' }, { atributo: 1, label: 'Tabela' }],
      dadosMensais: null,
      dadosEstatisticosMensais: null,
      tabelaConsolidados: {
        campos: [{
          name: 'data',
          sortField: 'data',
          title: this.$t('mobilidade.transporte.tabela.consolidado.ano'),
          width: '7.5%',
          callback: function (x) { return new Date(x).toLocaleDateString('pt-BR', { year: 'numeric', month: 'numeric' }) },
        }, {
          name: 'passageiros_pagantes_bilhete_unico_comum',
          sortField: 'passageiros_pagantes_bilhete_unico_comum',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_pagantes_bilhete_unico_comum'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'passageiros_pagantes_bilhete_unico_estudante_mensal',
          sortField: 'passageiros_pagantes_bilhete_unico_estudante_mensal',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_pagantes_bilhete_unico_estudante_mensal'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'passageiros_pagantes_bilhete_unico_vt_mensal',
          sortField: 'passageiros_pagantes_bilhete_unico_vt_mensal',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_pagantes_bilhete_unico_vt_mensal'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'passageiros_pagantes_comum_e_vt',
          sortField: 'passageiros_pagantes_comum_e_vt',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_pagantes_comum_e_vt'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'passageiros_pagantes_em_dinheiro',
          sortField: 'passageiros_pagantes_em_dinheiro',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_pagantes_em_dinheiro'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'passageiros_pagantes_estudante',
          sortField: 'passageiros_pagantes_estudante',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_pagantes_estudante'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'passageiros_com_gratuidade_estudante',
          sortField: 'passageiros_com_gratuidade_estudante',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_com_gratuidade_estudante'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'passageiros_com_gratuidade',
          sortField: 'passageiros_com_gratuidade',
          title: this.$t('mobilidade.transporte.tabela.consolidado.passageiros_com_gratuidade'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'total_integracoes_onibus_onibus',
          sortField: 'total_integracoes_onibus_onibus',
          title: this.$t('mobilidade.transporte.tabela.consolidado.total_integracoes_onibus_onibus'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'total_passageiros_pagantes',
          sortField: 'total_passageiros_pagantes',
          title: this.$t('mobilidade.transporte.tabela.consolidado.total_passageiros_pagantes'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }, {
          name: 'total_passageiros_transportados',
          sortField: 'total_passageiros_transportados',
          title: this.$t('mobilidade.transporte.tabela.consolidado.total_passageiros_transportados'),
          callback: function (x) { return x.toLocaleString('pt-BR') },
          width: '7.5%',
        }],
        dados: [],
        itemsPerPage: 10,
      },
      tabelaEstatisticas: {
        campos: [{
          name: 'data_contabilizacao',
          sortField: 'data_contabilizacao',
          title: this.$t('mobilidade.transporte.tabela.estatistico.data_contabilizacao'),
          width: '7.5%',
          callback: function (x) { return new Date(x).toLocaleDateString('pt-BR', { year: 'numeric', month: 'short' }) },
        },
        {
          name: 'dia_da_semana',
          sortField: 'dia_da_semana',
          title: this.$t('mobilidade.transporte.tabela.estatistico.dia_da_semana'),
          width: '7.5%',
        },
        {
          name: 'media_passageiros_transportados',
          sortField: 'media_passageiros_transportados',
          title: this.$t('mobilidade.transporte.tabela.estatistico.media_passageiros_transportados'),
          width: '7.5%',
          callback: function (x) { return x.toLocaleString('pt-BR') },
        },
        {
          name: 'mediana_passageiros_transportados',
          sortField: 'mediana_passageiros_transportados',
          title: this.$t('mobilidade.transporte.tabela.estatistico.mediana_passageiros_transportados'),
          width: '7.5%',
          callback: function (x) { return x.toLocaleString('pt-BR') },
        }],
        dados: [],
        itemsPerPage: 10,
        sortFunctions: {
          'dia_da_semana': MethGlob.ordenaTabelaDiasDaSemana,
          'mediana_passageiros_transportados': MethGlob.ordenaTabelaParseFloat,
          'media_passageiros_transportados': MethGlob.ordenaTabelaParseFloat,
        },
      },
      chartEstatistico: {
        data: {},
        options: {},
      },
      chartConsolidado: {
        data: {},
        options: {},
      },
      cards: { dataRef: new Date() },
    }
  },

  computed: {
    header: function () {
      return this.$t('rodape.referenteData', { fonte: this.fonte, data: this.cards.dataRef.toLocaleDateString('pt-BR', { year: 'numeric', month: 'short' }) })
    },
    periodo: function () {
      return this.dataInicio.toLocaleDateString('pt-BR', { year: 'numeric', month: 'numeric' }) + ' à ' + this.data_referencia.toLocaleDateString('pt-BR', { year: 'numeric', month: 'numeric' }) || new Date().toLocaleDateString('pt-BR')
    },
  },

  created () {
    Promise.all([
      this.$store.dispatch('transportes/totalPassageriosSPTransConsolidado', { dataInicio: this.dataInicio.toISOString().split("T")[0], dataFim: this.dataFim.toISOString().split("T")[0], agrupamento: this.agrupamentos[4] }),
      this.$store.dispatch('transportes/totalPassageirosSPTransEstatisticaMes', { dataInicio: this.dataInicio.toISOString().split("T")[0], dataFim: this.dataFim.toISOString().split("T")[0] }),
      // this.$store.dispatch('transportes/totalPassageirosSPTransTransportadosSazonal'),
    ]).then((respostas) => {
      this.fonte = (respostas[0].data.sigla_orgao + '/' + respostas[0].data.fonte)
      this.data_referencia = new Date(respostas[0].data.data_referencia_dado)
      this.colorSet = CorUtils.getVetorCoresPorTom('medio').slice(6)

      this.dataRef = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.data_referencia.toLocaleDateString('pt-BR') })
      this.cardRef = this.$t('rodape.referenteData', { fonte: this.fonte, data: this.cards.dataRef.toLocaleDateString('pt-BR', { year: 'numeric', month: 'short' }) })

      // Chart 2
      this.dadosConsolidados = respostas[0].data.data
      this.tabelaConsolidados.dados = this.dadosConsolidados
      this.chartConsolidado.data = this.montarGraficoPorMes()
      this.chartConsolidado.options = {
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              // parser: 'YYYY-MM-DD HH:mm:ss',
              unit: 'month',
              displayFormats: {
                month: 'MMM-YYYY',
              },

            },
            ticks: {
              source: 'data',
              min: this.dataInicio,
              max: this.dataFim,
              callback: function (value, index, values) {
                return new Date(value).toLocaleDateString('pt-BR', { year: 'numeric', month: 'short' })
              },
            },
          }],
          yAxes: [
            {
              id: 'A',
              position: 'left',
              beginAtZero: true,
              type: 'logarithmic',

              scaleLabel: {
                display: true,
                labelString: 'Passageiros transportados',
              },
              ticks: {
                maxTicksLimit: 15,
                // max: 100,
                callback: function (value, index, values) {
                  return value.toLocaleString('pt-BR')
                },
              },
            },
            // {
            //   id: 'B',
            //   position: 'right',
            //   scaleLabel: {
            //     display: true,
            //     labelString: 'Passageiros Transportados',
            //   },
            //   ticks: {
            //     beginAtZero: true,
            //     callback: function (value, index, values) {
            //       return value.toLocaleString('pt-BR')
            //     },
            //   },
            // },
          ],
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItem, data) {
              return new Date(tooltipItem[0].label).toLocaleDateString('pt-BR', { year: 'numeric', month: 'short' })
            },
            label: function (tooltipItem, details) {
              return details.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toLocaleString('pt-BR')
            },
          },
        },
        plugins: {
          datalabels: { display: false },
          // annotation: {
          //   annotations: {
          //     box1: {
          //       // Indicates the type of annotation
          //       type: 'box',
          //       xMin: 1,
          //       xMax: 2,
          //       yMin: 50,
          //       yMax: 70,
          //       backgroundColor: 'rgba(255, 99, 132, 0.25)',
          //     },
          //     line1: {
          //       type: 'line',
          //       yMin: 0,
          //       yMax: 1000,
          //       xMax: 15,
          //       borderColor: 'rgb(255, 99, 132)',
          //       borderWidth: 2,
          //     },
          //   },
          // },
        },
      }

      // chart 1
      this.dadosEstatisticosMensais = respostas[1].data.data
      this.dadosEstatisticosMensais = _.orderBy(this.dadosEstatisticosMensais, 'data_contabilizacao', ['ASC'])
      this.dadosAgrupados = _.groupBy(this.dadosEstatisticosMensais, 'dia_da_semana')

      this.tabelaEstatisticas.dados = this.dadosEstatisticosMensais

      this.chartEstatistico.data = this.montarGraficoEstatistico()
      this.chartEstatistico.options = {
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              // parser: 'YYYY-MM-DD HH:mm:ss',
              unit: 'week',
              displayFormats: {
                month: 'WW-MMM-YYYY',
              },

            },
            ticks: {
              source: 'data',
              // min: this.dataInicio,
              max: this.dataFim,
              callback: function (value, index, values) {
                return new Date(value).toLocaleDateString('pt-BR', { year: 'numeric', month: 'numeric', week: 'numeric' })
              },
            },
          }],
          yAxes: [
            {
              id: 'A',
              position: 'left',
              // stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'Média de Passageiros Transportados',
              },
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return value.toLocaleString('pt-BR')
                },
              },
            },

          ],
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItem, data) {
              return new Date(tooltipItem[0].label).toLocaleDateString('pt-BR', { year: 'numeric', month: 'short' })
            },
            label: function (tooltipItem, details) {
              return details.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel.toLocaleString('pt-BR')
            },
          },
        },
        plugins: {
          datalabels: { display: false },
          // annotation: {
          //   annotations: {
          //     box1: {
          //       // Indicates the type of annotation
          //       type: 'box',
          //       xMin: 1,
          //       xMax: 2,
          //       yMin: 50,
          //       yMax: 70,
          //       backgroundColor: 'rgba(255, 99, 132, 0.25)',
          //     },
          //     line1: {
          //       type: 'line',
          //       yMin: 0,
          //       yMax: 1000,
          //       xMax: 15,
          //       borderColor: 'rgb(255, 99, 132)',
          //       borderWidth: 2,
          //     },
          //   },
          // },
        },
      }
    })
  },

  methods: {
    montarGraficoPorMes () {
      let chartData = {
        datasets: [],
        labels: [],
      }

      let colors = _.cloneDeep(this.colorSet)

      this.calcularProporcoes()

      let pagamentosEmDinheiro = []
      let gratuidades = []
      let gratuidadesXPagantes = []
      let integracoesXPassageiros = []
      let passageirosTransportadosXBilheteMensal = []
      let passageirosPagantes = []
      let estudantesTransportados = []

      let passageiros_pagantes_bilhete_unico_comum = []
      let passageiros_pagantes_bilhete_unico_estudante_mensal = []
      let passageiros_pagantes_bilhete_unico_vt_mensal = []
      let passageiros_pagantes_comum_e_vt = []
      let passageiros_pagantes_em_dinheiro = []
      let passageiros_pagantes_estudante = []
      let passageiros_com_gratuidade_estudante = []
      let passageiros_com_gratuidade = []

      this.dadosConsolidados.forEach((e) => {
        pagamentosEmDinheiro.push(e.logos.pagamentosEmDinheiro)
        gratuidades.push(e.logos.gratuidades)
        gratuidadesXPagantes.push(e.logos.gratuidadesXPagantes)
        integracoesXPassageiros.push(e.logos.integracoesXPassageiros)
        passageirosTransportadosXBilheteMensal.push(e.logos.passageirosTransportadosXBilheteMensal)
        passageirosPagantes.push(e.logos.pagantes)
        estudantesTransportados.push(e.logos.estudantesTransportados)
        chartData.labels.push(e.ano + '-' + e.mes)

        passageiros_pagantes_bilhete_unico_comum.push(e.passageiros_pagantes_bilhete_unico_comum)
        passageiros_pagantes_bilhete_unico_estudante_mensal.push(e.passageiros_pagantes_bilhete_unico_estudante_mensal)
        passageiros_pagantes_bilhete_unico_vt_mensal.push(e.passageiros_pagantes_bilhete_unico_vt_mensal)
        passageiros_pagantes_comum_e_vt.push(e.passageiros_pagantes_comum_e_vt)
        passageiros_pagantes_em_dinheiro.push(e.passageiros_pagantes_em_dinheiro)
        passageiros_pagantes_estudante.push(e.passageiros_pagantes_estudante)
        passageiros_com_gratuidade_estudante.push(e.passageiros_com_gratuidade_estudante)
        passageiros_com_gratuidade.push(e.passageiros_com_gratuidade)
      })

      chartData.datasets = [
        // this.defineDatasetGenerico('Pagamentos em Dinheiro', colors.shift(), pagamentosEmDinheiro),
        // this.defineDatasetGenerico('Gratuidades X Total', colors.shift(), gratuidades),
        // this.defineDatasetGenerico('Gratuidades X Pagantes', colors.shift(), gratuidadesXPagantes),
        // this.defineDatasetGenerico('integracoesXPassageiros', colors.shift(), integracoesXPassageiros),
        // this.defineDatasetGenerico('Bilhete Unico Mensal', colors.shift(), passageirosTransportadosXBilheteMensal),
        // this.defineDatasetGenerico('Estudantes Transportados', colors.shift(), estudantesTransportados),
        // this.defineDatasetGenerico('Passageiros Pagantes', colors.shift(), passageirosPagantes),

        this.defineDatasetGenerico('BILHETE UNICO ESTUDANTE MENSAL', colors.shift(), passageiros_pagantes_bilhete_unico_estudante_mensal),
        this.defineDatasetGenerico('BILHETE UNICO VT MENSAL', colors.shift(), passageiros_pagantes_bilhete_unico_vt_mensal),
        this.defineDatasetGenerico('ESTUDANTE', colors.shift(), passageiros_pagantes_estudante),
        this.defineDatasetGenerico('BILHETE UNICO COMUM', colors.shift(), passageiros_pagantes_bilhete_unico_comum),
        this.defineDatasetGenerico('COMUM E VT', colors.shift(), passageiros_pagantes_comum_e_vt),

        this.defineDatasetGenerico('EM DINHEIRO', colors.shift(), passageiros_pagantes_em_dinheiro),
        this.defineDatasetGenerico('GRATUIDADE ESTUDANTE', colors.shift(), passageiros_com_gratuidade_estudante),
        this.defineDatasetGenerico('GRATUIDADE', colors.shift(), passageiros_com_gratuidade),
      ]
      return chartData
    },

    calcularProporcoes () {
      this.dadosConsolidados.forEach((d) => {
        d.logos = {
          pagamentosEmDinheiro: (d.passageiros_pagantes_em_dinheiro / d.total_passageiros_pagantes) * 100,
          gratuidades: (d.passageiros_com_gratuidade / d.total_passageiros_transportados) * 100,
          gratuidadesXPagantes: (d.passageiros_com_gratuidade / d.total_passageiros_pagantes) * 100,
          integracoesXPassageiros: (d.total_integracoes_onibus_onibus / d.total_passageiros_transportados) * 100,
          passageirosTransportadosXBilheteMensal: ((d.passageiros_pagantes_bilhete_unico_vt_mensal + d.passageiros_pagantes_bilhete_unico_estudante_mensal) / d.total_passageiros_transportados) * 100,
          estudantesTransportados: ((d.passageiros_com_gratuidade_estudante + d.passageiros_pagantes_bilhete_unico_estudante_mensal) / d.total_passageiros_transportados) * 100,
          pagantes: (d.total_passageiros_pagantes / d.total_passageiros_transportados) * 100,
        }
        d.data = new Date(d.ano + '-' + d.mes)
      })

      this.cards.transportados = this.dadosConsolidados[this.dadosConsolidados.length - 2].total_passageiros_transportados
      this.cards.pagantes = this.dadosConsolidados[this.dadosConsolidados.length - 2].total_passageiros_pagantes
      this.cards.pagantesPerc = this.dadosConsolidados[this.dadosConsolidados.length - 2].logos.pagantes
      this.cards.gratuidades = this.dadosConsolidados[this.dadosConsolidados.length - 2].passageiros_com_gratuidade
      this.cards.gratuidadesPerc = this.dadosConsolidados[this.dadosConsolidados.length - 2].logos.gratuidades
      this.cards.dataRef = this.dadosConsolidados[this.dadosConsolidados.length - 2].data
    },

    montarGraficoEstatistico () {
      let chartData = {
        datasets: [],
      }

      let order = this.ordenarEmDiasDaSemana()
      let colors = _.cloneDeep(this.colorSet)

      for (const key in order) {
        if (Object.hasOwnProperty.call(order, key)) {
          const element = order[key]
          chartData.datasets.push(this.montarDataSet(element, 'dia_da_semana', 'media_passageiros_transportados', colors.shift()))
        }
      }
      return chartData
    },

    montarDataSet (dados, labelProp, prop, color) {
      dados = _.orderBy(dados, 'data_contabilizacao', ['asc'])
      let dataset = {
        label: '',
        backgroundColor: color,
        borderColor: color,
        data: [],
        fill: this.$store.getters.palette.transparent,
      }

      dados.forEach(el => {
        dataset.label = el[labelProp]
        dataset.data.push({ y: el[prop], x: el.data_contabilizacao })
      })

      return dataset
    },

    defineDatasetGenerico (label, borderColor, data, axisID, type = 'bar') {
      return {
        label: label,
        backgroundColor: borderColor, // this.$store.getters.palette.transparent,
        borderColor: borderColor,
        data: data,
        yAxisID: axisID,
        type: type,
      }
    },

    ordenarEmDiasDaSemana () {
      let order = {}
      order['Domingo'] = this.dadosAgrupados['Domingo']
      order['Segunda-feira'] = this.dadosAgrupados['Segunda-feira']
      order['Terça-feira'] = this.dadosAgrupados['Terça-feira']
      order['Quarta-feira'] = this.dadosAgrupados['Quarta-feira']
      order['Quinta-feira'] = this.dadosAgrupados['Quinta-feira']
      order['Sexta-feira'] = this.dadosAgrupados['Sexta-feira']
      order['Sábado'] = this.dadosAgrupados['Sábado']
      return order
    },
  },

}
</script>

<style lang="scss" scoped>
    .chartPanel{
        max-height: 40rem;
        width: 100%;
    }
</style>
